export class JobFailedEvent {
  public readonly reviewId: number;
  public readonly reviewItemId: number;
  public readonly operation: string;
  public readonly error: string;
  public readonly attempts: number;

  constructor(
    reviewId: number,
    reviewItemId: number,
    operation: string,
    error: string,
    attempts: number,
  ) {
    this.reviewId = reviewId;
    this.reviewItemId = reviewItemId;
    this.operation = operation;
    this.error = error;
    this.attempts = attempts;
  }
}
